export default "__VITE_ASSET__DiVYAEmr__"